module.exports = __webpack_public_path__ + "img/house-icon-on.c960eb32.svg";